import { Component, signal } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { isAllowed } from '../../../../../modules/shared/shared.global-service';
import { TableColumn, TableColumnType } from '../../../../../modules/shared/components/kit/table/table.types';
import { dateTimeField, doctorChipField } from '../../../../../modules/shared/components/kit/table/table.fields';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-folder-sick-notes-submission-history-modal',
    templateUrl: 'folder-sick-notes-submission-history-modal.component.html',
    styleUrls: ['folder-sick-notes-submission-history-modal.component.scss'],
    imports: [
        ActionButtonsComponent,
        TableComponent,
    ],
})
export class FolderSickNotesSubmissionHistoryModalComponent extends BaseDialogComponent {
    protected items = signal<any[]>([
        {
            id: 1,
            date: new Date(new Date().setDate(new Date().getDate() - 1)),
            status: 'ok',
            doctor: {
                'id': '98ec15de-0cca-413a-ae96-64e9ba66976e',
                'name': 'Vladimíra',
                'surname': 'Štětková',
                'titleAfterName': null,
                'titleBeforeName': 'MUDr.',
            },
            requestId: '5e83b6c1-331a-4b24-af05-b884',
            answerId: '9b36d6d0-1964-4cbe-beb6-aaf1',
            dateReply: new Date(new Date().setDate(new Date().getDate() + 14)),
        },
        {
            id: 2,
            date: new Date(new Date().setDate(new Date().getDate() - 2)),
            status: 'sent',
            doctor: {
                'id': '98ec15de-0cca-413a-ae96-64e9ba66976e',
                'name': 'Vladimíra',
                'surname': 'Štětková',
                'titleAfterName': null,
                'titleBeforeName': 'MUDr.',
            },
            requestId: '5e83b6c1-331a-4b24-af05-b884',
            dateReply: new Date(new Date().setDate(new Date().getDate() + 14)),
        },
        {
            id: 3,
            date: new Date(new Date().setDate(new Date().getDate() - 3)),
            status: 'error',
            doctor: {
                'id': '98ec15de-0cca-413a-ae96-64e9ba66976e',
                'name': 'Vladimíra',
                'surname': 'Štětková',
                'titleAfterName': null,
                'titleBeforeName': 'MUDr.',
            },
            requestId: '5e83b6c1-331a-4b24-af05-b884',
            answerId: '9b36d6d0-1964-4cbe-beb6-aaf1',
            dateReply: new Date(new Date().setDate(new Date().getDate() + 14)),
        },
    ]);

    protected columns: TableColumn[] = [
        dateTimeField('date'),
        {
            name: 'status',
            type: TableColumnType.Tag,
            filterable: {
                selectOptions: () => ['ok', 'sent', 'error'],
            },
            tagOptions: {
                labelPrefix: '',
                //personStatusColor[item] || undefined,
            },
            severity: (item: string) => {
                return item === 'ok' ? 'primary' : item === 'sent' ? 'success' : 'danger';
            },
        },
        doctorChipField('doctor'),
        {
            name: 'requestId',
        },
        {
            name: 'answerId',
        },
        dateTimeField('dateReply'),
    ];

    protected readonly isAllowed = isAllowed;
}
